// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { SubmissionError } from 'redux-form'

import {
  setPricingManagementSelectedPricingGroupDef,
  setPricingManagementData,
} from 'redux/modules/pricingManagement'

import {
  assembleQuery,
  fetchWrapper,
} from 'helpers/api'

const handlePricingManagementSearch = formValues => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      try {
        // blurs the active DOM element
        document.activeElement.blur()

        const {
          pricingGroupType,
          pricingGroupDefSearch,
        } = formValues

        const query = assembleQuery([{
          field: 'pricing_group_type',
          value: pricingGroupType,
        }, {
          field: 'pricing_group_def',
          value: pricingGroupDefSearch,
        }])

        const data = await fetchWrapper(`/priceManagement${query}`)

        // clears selected pricing group def records
        dispatch(setPricingManagementSelectedPricingGroupDef())
        // sets new data
        dispatch(setPricingManagementData(data))
      } catch (err) {
        console.warn(err)
        throw new SubmissionError({
          _error: err.message || 'Uncaught Error!',
        })
      }
    })
  )
)

export default handlePricingManagementSearch
